import type { Nullish } from '@logistiek-zonder-papier/lzp-library'
import { type UUID } from 'crypto'

export type Customer = {
  id: UUID
  modules: number[]
  name: string | Nullish
  email: string | Nullish
  phone: string | Nullish
  address: Address | Nullish
  addressId: UUID
  imageFileId?: string | Nullish
  billingAddress: Address | Nullish
  billingAddressId: UUID | Nullish
  billingEmail: string | Nullish
  billingPhone: string | Nullish
  identificationNumber: string | Nullish
  taxNumber: string | Nullish
  iban: string | Nullish
  bic: string | Nullish
  auth0Issuer?: string | Nullish
  auth0Audience?: string | Nullish
}

export type Address = {
  id?: UUID | Nullish
  createdAt?: Date | Nullish
  updatedAt?: Date | Nullish
  customerId?: UUID | Nullish
  postalCode: string | Nullish
  city: string | Nullish
  street: string | Nullish
  street2?: string | Nullish
  houseNumber: string | Nullish
  country: string | Nullish
  suffix?: string | Nullish
  longitude?: number | Nullish
  latitude?: number | Nullish
}

export function createEmptyAddress(): Address {
  return {
    postalCode: '',
    city: '',
    street: '',
    houseNumber: '',
    country: '',
    suffix: '',
  }
}
export type VatValidationResult = {
  address: {
    city: string
    country: string
    countryCode: string
    number: string
    street: string
    zip_code: string
  }
  countryCode: string
  name: string
  strAddress: string
  valid: boolean
  vatNumber: string
}
